import React from 'react';
import './style.scss';
import Button from '../../../../controls/button';
import useWeb3 from '../../../../../contexts/web3';
import useUserData from '../../../../../contexts/userData';
import clsx from 'clsx';

interface Props {
  hideDownload: boolean;
}

const LandingMainSection = ({ hideDownload }: Props) => {
  const { handleMetamaskClick } = useWeb3();
  const { login, loginLoading } = useUserData();

  const handlePlayClick = () => handleMetamaskClick(login, 'login/signup');

  return (
    <section
      id='main-section'
      className={clsx(
        'landing-main-section-wrapper',
        process.env.REACT_APP_BANNER_ENABLED && 'with-banner',
      )}
    >
      <div className='lms-content'>
        <div className='lms-content-image-wrapper'>
          <img
            src='../../../../../assets/images/landing/main_page/hands.png'
            className='lms-content-image'
            alt='Hands'
          />
        </div>
        <h1 className='lms-content-wording'>nifty hands</h1>
        <p className='lms-content-description'>
          Fight-to-earn in the crypto version of Rock, Paper, Scissors 🎮✊👋✌️.
        </p>
        <div className='lms-content-buttons-wrapper'>
          <Button
            className='lmscb-play'
            onClick={handlePlayClick}
            loading={loginLoading}
          >
            Play Now
          </Button>
          {!hideDownload && (
            <>
              <div className='lmscb-text'>OR</div>
              <div className='lmscb'>
                <img
                  src={'/assets/images/landing/main_page/google.png'}
                  className='lmscb-button'
                  alt='Google Play Button'
                />
                <img
                  src={'/assets/images/landing/main_page/apple.svg'}
                  className='lmscb-button'
                  alt='App Store Button'
                />
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default LandingMainSection;
